module.exports = __webpack_public_path__ + "img/currency-exchange.013bc279.svg";